import { useState, useEffect } from 'react'

export const useFetchAssignments = ({ marvarApi, dispatch, onLogout }) => {

    const [dataAssignments, setDataAssignments] = useState([])

    const [loadingFetchAssignments, setLoadingFetchAssignments] = useState(false)

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataAssignments([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja/assignments`)
            console.log('[useFetchData][useFetchAssignments] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAssignments(true)
        fetchData()
            .then((resp) => {
                setDataAssignments(resp.rows)
                setLoadingFetchAssignments(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAssignments(false)
            })
    }, [execute])

    return { dataAssignments, loadingFetchAssignments, executeFetch, resetFetch }
}

export const useFetchCategories = ({ marvarApi, dispatch, onLogout }) => {

    const [ dataCategories, setDataCategories ] = useState([])

    const [ loadingFetchCategories, setLoadingFetchCategories ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCategories([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja/categories`)
            // console.log('[useFetchData][useFetchCategories] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCategories(false)
            })
    }, [execute])

    return { dataCategories, loadingFetchCategories, executeFetch, resetFetch }
}

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashRegisters, setDataCashRegisters ] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashRegisters([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type),
            }
            const response = await marvarApi.post(`/caja/fetch-cashier-by-category-currency`, _body)
            // console.log('[useFetchData][useFetchAllCashRegisters] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashRegisters(true)
            fetchData()
                .then((resp) => {
                    setDataCashRegisters(resp.rows)
                    setLoadingFetchCashRegisters(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashRegisters(false)
                })
        }
    }, [execute])

    return { dataCashRegisters, loadingFetchCashRegisters, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchUsers = ({ marvarApi, dispatch, onLogout }) => {

    const [ dataUsers, setDataUsers ] = useState([])

    const [ loadingFetchUsers, setLoadingFetchUsers ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataUsers([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja/users`)
            console.log('[useFetchData][useFetchUsers] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchUsers(true)
        fetchData()
            .then((resp) => {
                setDataUsers(resp.rows)
                setLoadingFetchUsers(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchUsers(false)
            })
    }, [execute])

    return { dataUsers, loadingFetchUsers, executeFetch, resetFetch }
}